import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TodoViewInnerProps } from "models/propTypes/todoPropTypes";
//#endregion
//#region components
import {
  IncomingInvoiceTodoToApprove,
  GenericDocumentSentBackTodo,
  SalaryDeviationReportTodo,
  IncomingInvoiceTodoFinalApprove,
  SalaryDeviationAndTimeLogReportTodo,
  IncomingInvoiceTodoMissingApproval,
  ReceiptTodoToApprove,
  SupportIssueTodo,
  ReceiptTodoSentBack,
  ReceiptDraftTodo,
  ProfileRoutineTodo,
  SalaryPaymentReportTodo,
  MissingDocumentTodo,
  AgentSaleMissingInformationTodo,
  UnhandledBankPaymentsTodo,
  BankPortalSigningTodo,
  BankIdPaymentsTodo,
  InvoiceTodoOverdue,
  InvoiceTodoReminderFeeNotPaid,
  DocumentDraftTodo,
  SupplementaryMaterialTodo,
  SalaryDraftTodo,
  InvoiceTodoDraft,
  StoppedPaymentsTodo,
  PausedPaymentsTodo,
  QualifiedShareDividendsTodoToApprove,
  AnnualAccountSurveyTodo,
  AnnualAccountToApproveTodo,
  UpdateBoardMembersDataTodo,
  ShareRegisterTodoToApprove,
  SalaryDeviationReportWithBusinessUnitsTodo,
  OverPaidAgingIncomingInvoiceTodo,
  UnderPaidAgingIncomingInvoiceTodo,
  SelfInvoiceTodo,
  AnnualReportSigningStepsTodo,
  AnnualReportAuditorSigningStepsTodo,
  WintSalaryAprrovalTodo,
  RemovedDocumentDraftTodo,
  ExternalCompanyHoldingsTodo,
  ClassifiedReceiptTodo,
  PreliminaryTaxUpdateTodo,
  RevenueReportApprovalTodo
} from "components/todos/todoCards";
import EntityCardLayout from "components/common/pageLayouts/entityCardLayout";
import { useTodoService } from "serviceHooks";
//#endregion

const TodoViewInner: React.FC<TodoViewInnerProps> = (props) => {
  const todoService = useTodoService();
  const { todo, onSuccess } = props;

  const getComponent = () => {
    if (todo.type === WintSuperkollAPIModel.TodoType.SupplementaryMaterial) {
      return SupplementaryMaterialTodo;
    } else {
      switch (todo.subType) {
        case WintSuperkollAPIModel.TodoSubType.IncomingInvoiceToApprove:
          return IncomingInvoiceTodoToApprove;
        case WintSuperkollAPIModel.TodoSubType.IncomingInvoiceFinalApproval:
          return IncomingInvoiceTodoFinalApprove;
        case WintSuperkollAPIModel.TodoSubType.IncomingInvoiceMissingApproval:
          return IncomingInvoiceTodoMissingApproval;
        case WintSuperkollAPIModel.TodoSubType.AgingIncomingInvoiceOverPaid:
          return OverPaidAgingIncomingInvoiceTodo;
        case WintSuperkollAPIModel.TodoSubType.AgingIncomingInvoiceLeftToPay:
          return UnderPaidAgingIncomingInvoiceTodo;
        case WintSuperkollAPIModel.TodoSubType.ReceiptDraft:
          return ReceiptDraftTodo;
        case WintSuperkollAPIModel.TodoSubType.ReceiptToApprove:
          return ReceiptTodoToApprove;
        case WintSuperkollAPIModel.TodoSubType.ReceiptSentBack:
          return ReceiptTodoSentBack;
        case WintSuperkollAPIModel.TodoSubType.Support:
          return SupportIssueTodo;
        case WintSuperkollAPIModel.TodoSubType.MissingDocument:
          return MissingDocumentTodo;
        case WintSuperkollAPIModel.TodoSubType.GenericVouchersSentBack:
          return GenericDocumentSentBackTodo;
        case WintSuperkollAPIModel.TodoSubType.SalaryDeviationReport:
          return SalaryDeviationReportTodo;
        case WintSuperkollAPIModel.TodoSubType.QualifiedShareDividend:
          return QualifiedShareDividendsTodoToApprove;
        case WintSuperkollAPIModel.TodoSubType.DocumentDraft:
          return DocumentDraftTodo;
        case WintSuperkollAPIModel.TodoSubType.SalaryDeviationAndTimeLogReport:
          return SalaryDeviationAndTimeLogReportTodo;
        case WintSuperkollAPIModel.TodoSubType.PersonSalaryReport:
          return SalaryPaymentReportTodo;
        case WintSuperkollAPIModel.TodoSubType.InvoiceOverdue:
          return InvoiceTodoOverdue;
        case WintSuperkollAPIModel.TodoSubType.InvoiceReminderFeeNotPaid:
          return InvoiceTodoReminderFeeNotPaid;
        case WintSuperkollAPIModel.TodoSubType.SalaryDraft:
          return SalaryDraftTodo;
        case WintSuperkollAPIModel.TodoSubType.InvoiceDraft:
          return InvoiceTodoDraft;
        case WintSuperkollAPIModel.TodoSubType.UnhandledSelfInvoice:
          return SelfInvoiceTodo;
        case WintSuperkollAPIModel.TodoSubType.Survey:
          return AnnualAccountSurveyTodo;
        case WintSuperkollAPIModel.TodoSubType.AnnualAccountsForCustomerApproval:
          return AnnualAccountToApproveTodo;
        case WintSuperkollAPIModel.TodoSubType.PaymentSigningInformation:
          return BankIdPaymentsTodo;
        case WintSuperkollAPIModel.TodoSubType.UnhandledBankPayments:
          return UnhandledBankPaymentsTodo;
        case WintSuperkollAPIModel.TodoSubType.BankPortalSigning:
          return BankPortalSigningTodo;
        case WintSuperkollAPIModel.TodoSubType.AgentSaleMissingInformation:
          return AgentSaleMissingInformationTodo;
        case WintSuperkollAPIModel.TodoSubType.StoppedPayment:
          return StoppedPaymentsTodo;
        case WintSuperkollAPIModel.TodoSubType.PausedPayments:
          return PausedPaymentsTodo;
        case WintSuperkollAPIModel.TodoSubType.ProfileRoutine:
          return ProfileRoutineTodo;
        case WintSuperkollAPIModel.TodoSubType.UpdateNewBoardMembersData:
          return UpdateBoardMembersDataTodo;
        case WintSuperkollAPIModel.TodoSubType.ShareRegisterConfirmationToApprove:
          return ShareRegisterTodoToApprove;
        case WintSuperkollAPIModel.TodoSubType.SalaryDeviationReportWithBusinessUnits:
          return SalaryDeviationReportWithBusinessUnitsTodo;
        case WintSuperkollAPIModel.TodoSubType.AnnualReportSigningSteps:
          return AnnualReportSigningStepsTodo;
        case WintSuperkollAPIModel.TodoSubType.AuditorAnnualReportSigningSteps:
          return AnnualReportAuditorSigningStepsTodo;
        case WintSuperkollAPIModel.TodoSubType.WintSalaryApprovalReport:
          return WintSalaryAprrovalTodo;
        case WintSuperkollAPIModel.TodoSubType.ExternalCompanyHoldings:
          return ExternalCompanyHoldingsTodo;
        case WintSuperkollAPIModel.TodoSubType.RemovedDocumentDraft:
          return RemovedDocumentDraftTodo;
        case WintSuperkollAPIModel.TodoSubType.ClassifiedReceiptTodo:
          return ClassifiedReceiptTodo;
        case WintSuperkollAPIModel.TodoSubType.PreliminaryTaxUpdate:
          return PreliminaryTaxUpdateTodo;
        case WintSuperkollAPIModel.TodoSubType.RevenueReportNotSubmitted:
          return RevenueReportApprovalTodo;
        default:
          return undefined;
      }
    }
  };

  const getHasFileViewerInitially = () => {
    if (todo.type === WintSuperkollAPIModel.TodoType.SupplementaryMaterial) {
      return true;
    } else {
      switch (todo.subType) {
        case WintSuperkollAPIModel.TodoSubType.Support:
        case WintSuperkollAPIModel.TodoSubType.MissingDocument:
        case WintSuperkollAPIModel.TodoSubType.Survey:
        case WintSuperkollAPIModel.TodoSubType.AgentSaleMissingInformation:
        case WintSuperkollAPIModel.TodoSubType.ProfileRoutine:
        case WintSuperkollAPIModel.TodoSubType.PreliminaryTaxUpdate:
          return false;
        default:
          return true;
      }
    }
  };

  const Component = getComponent();

  return (
    <EntityCardLayout
      hasInfoViewerInitially={getHasFileViewerInitially()}
      widerCardLayout={todo.type === WintSuperkollAPIModel.TodoType.Support}
    >
      {Component ? (
        <Component
          key={`${todo.guidId ?? todo.id}-${todo.subType}`}
          item={todo}
          displayType={todoService.getUIDisplayTypeByUrgency(props.todo.urgency)}
          onActionSuccess={onSuccess}
        />
      ) : (
        <></>
      )}
    </EntityCardLayout>
  );
};

export default TodoViewInner;
